import { render } from "./PrenotazioniSetting.vue?vue&type=template&id=07cfad6f&scoped=true"
import script from "./PrenotazioniSetting.vue?vue&type=script&lang=js"
export * from "./PrenotazioniSetting.vue?vue&type=script&lang=js"

import "./PrenotazioniSetting.vue?vue&type=style&index=0&id=07cfad6f&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cfad6f"]])

export default __exports__